import React from 'react';
import NotFound from '../styles/assets/images/not-found';

const NotFoundContainer = () => (
  <div className="main-not-found__section">
    <NotFound />
    <p className="main-not-found__section-header">This page is lost...</p>
  </div>
);

export default NotFoundContainer;
